export const DeviceBasicDetailsPathCoCo = () => {
  return <></>;
};
